import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { AllocationRulesContext } from '../context';
import { SORT_FIELD_DATE } from '../rule-helper';
import messages from '../messages';

const SortFieldTotalDescending = ({ allocationRuleId }) => {
  const { allocationRules, setAllocationRules } = useContext(AllocationRulesContext);
  const rule = allocationRules.find((r) => r.allocationRuleId === allocationRuleId);
  const onChange = useCallback(() => {
    rule.sortDesc = true;
    rule.sortField = SORT_FIELD_DATE;
    setAllocationRules([...allocationRules.filter((r) => r.allocationRuleId !== rule.allocationRuleId), rule]);
  }, [rule, allocationRules, setAllocationRules]);

  if (rule.sortField === SORT_FIELD_DATE && rule.sortDesc) {
    return null;
  }
  return (
    <DropdownMenuItem onClick={onChange}>
      <FormattedMessage {...messages.allocationStrategiesNewestOrders} />
    </DropdownMenuItem>
  );
};

SortFieldTotalDescending.propTypes = {
  allocationRuleId: PropTypes.string.isRequired,
};

export default SortFieldTotalDescending;
